// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '9359e179-0b39-4e87-9693-5e434aa54b2e',
      type: 'Sprite',
      name: 'darkTile',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tile_dark',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'aec3a326-823a-4c74-ad0f-99e794a99bb5',
      type: 'Sprite',
      name: 'highlight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tile_hover',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'c5011885-97f0-4c02-a334-311d79890140',
      type: 'Container',
      name: 'particles',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '888fb40e-5f70-4993-915a-a84503e19823',
      type: 'Container',
      name: 'clap',
      className: '',
      x: 0,
      y: 10,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '6224df2e-7ad4-4225-b6e0-8b6c03de6a21',
      type: 'Text',
      name: 'freeText',
      className: '',
      x: 0,
      y: -42,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'FREE',
      localize: true,
      maxWidth: 70,
      maxHeight: 30,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        translations: {
          en_US: 'FREE',
          it_IT: 'GRATIS',
          fr_FR: 'GRATUIT',
          de_DE: 'GRATIS',
          es_ES: 'GRATIS',
          pt_PT: 'GRÁTIS',
          pl_PL: 'DARMOWY',
          nl_NL: 'GRATIS',
          ko_KR: '무료',
          ja_JP: '無料'
        }
      }
    },
    {
      id: '52cb97d0-6cf3-4bf6-bdb2-b95e9367e345',
      type: 'Container',
      name: 'clapTop',
      className: '',
      x: -30,
      y: -8,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '888fb40e-5f70-4993-915a-a84503e19823'
    },
    {
      id: 'd60425a5-c61e-4b14-b1f6-a0eead2a4df5',
      type: 'Container',
      name: 'clapBottom',
      className: '',
      x: 0,
      y: 13,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '888fb40e-5f70-4993-915a-a84503e19823'
    },
    {
      id: 'b24a1f3e-7e46-4fd4-870d-77f2c5f7e52f',
      type: 'Sprite',
      name: 'clapTopNormal',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.21,
        y: 0.67
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ad_Locked_Tiles_Icon_Top',
      parent: '52cb97d0-6cf3-4bf6-bdb2-b95e9367e345'
    },
    {
      id: 'db74b9bd-bddb-4b70-b4f7-1c0f3fed4b76',
      type: 'Sprite',
      name: 'clapTopWhite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.21,
        y: 0.67
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ad_Locked_Tiles_Icon_Top_White',
      parent: '52cb97d0-6cf3-4bf6-bdb2-b95e9367e345'
    },
    {
      id: '33f512a3-a331-472c-8895-272a488c6c51',
      type: 'Sprite',
      name: 'clapBottomNormal',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ad_Locked_Tiles_Icon_Bottom',
      parent: 'd60425a5-c61e-4b14-b1f6-a0eead2a4df5'
    },
    {
      id: '04d7bdf4-afae-4c32-b55e-8ea93424b47a',
      type: 'Sprite',
      name: 'clapBottomWhite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ad_Locked_Tiles_Icon_Bottom_White',
      parent: 'd60425a5-c61e-4b14-b1f6-a0eead2a4df5'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: '694bd060-00ef-47a8-b72e-c7a56d4db03e',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 5000,
      blocks: [
        {
          id: '3fa2d538-f65c-48d3-b0b9-d87ca5f85024',
          type: 'Tween',
          name: 'clapScale',
          duration: 100,
          track: 5,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 1000,
          sourceName: 'clap',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '782f25e5-ab43-4e5b-85d6-1052197a1e17',
          type: 'Tween',
          name: 'clapPosition_1_copy',
          duration: 100,
          track: 7,
          target: {
            y: 12
          },
          startAt: 1000,
          sourceName: 'clap',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '494059d8-897f-4fcc-98c9-098fd5690a80',
          type: 'Tween',
          name: 'clapScale_1',
          duration: 250,
          track: 5,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 1100,
          sourceName: 'clap',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: '8dca8af8-3ce9-4454-8b0c-295f9c426bd0',
          type: 'Tween',
          name: 'clapPosition_1',
          duration: 500,
          track: 7,
          target: {
            y: 4
          },
          startAt: 1100,
          sourceName: 'clap',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'c01cc1b5-ce2e-4f41-b26b-4477f83f2c72',
          type: 'Tween',
          name: 'clapTopWhiteAlpha',
          duration: 400,
          track: 3,
          target: {
            alpha: 0.3
          },
          startAt: 1200,
          sourceName: 'clapTopWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a0e5f2e1-9d91-4661-a443-f5de79a9c0c6',
          type: 'Tween',
          name: 'clapTopRotation',
          duration: 50,
          track: 4,
          target: {
            angle: 13
          },
          startAt: 1200,
          sourceName: 'clapTop',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ad6ca0b3-7f23-48b0-a14b-7248b25678f5',
          type: 'Tween',
          name: 'clapBottomWhiteAlpha',
          duration: 400,
          track: 2,
          target: {
            alpha: 0.3
          },
          startAt: 1200,
          sourceName: 'clapBottomWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '08d651ac-a5e3-4086-bead-b76fc98f4297',
          type: 'Tween',
          name: 'clapTopRotation_1',
          duration: 100,
          track: 4,
          target: {
            angle: 0
          },
          startAt: 1250,
          sourceName: 'clapTop',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3f19d8e6-a3fa-418d-8881-80f8308b0e8c',
          type: 'Tween',
          name: 'clapTopRotation_2',
          duration: 50,
          track: 4,
          target: {
            angle: 13
          },
          startAt: 1350,
          sourceName: 'clapTop',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '19fa5169-c1eb-492c-94cd-93d360a7d1ff',
          type: 'Tween',
          name: 'clapScale_1_1',
          duration: 300,
          track: 5,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1350,
          sourceName: 'clap',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'c1138620-5026-47ae-a2f4-7bbcd434df39',
          type: 'Tween',
          name: 'clapTopRotation_3',
          duration: 100,
          track: 4,
          target: {
            angle: 0
          },
          startAt: 1400,
          sourceName: 'clapTop',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '63345bf1-c071-489c-99c8-68968a5cb323',
          type: 'Tween',
          name: 'clapBottomWhiteAlpha_1',
          duration: 400,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 1600,
          sourceName: 'clapBottomWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c50d72a9-5464-44a5-ae6b-4f442ecf9eba',
          type: 'Tween',
          name: 'clapTopWhiteAlpha_1',
          duration: 400,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 1600,
          sourceName: 'clapTopWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd82fa335-1761-417b-a71c-ec0be3afe9e7',
          type: 'Tween',
          name: 'clapPosition',
          duration: 500,
          track: 7,
          target: {
            y: 10
          },
          startAt: 1600,
          sourceName: 'clap',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5d7b867d-bd4d-4af3-ad04-f971cde48f4a',
          type: 'Tween',
          name: 'clapScale_1_1_1',
          duration: 150,
          track: 5,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 1650,
          sourceName: 'clap',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '9e1e33a2-eb1d-4c0d-abdb-3fae481753f3',
          type: 'Tween',
          name: 'clapScale_1_1_1_1',
          duration: 200,
          track: 5,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1800,
          sourceName: 'clap',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: '1735fb79-7e57-4f41-b8a1-464f51708163',
          type: 'Tween',
          name: 'clapScale_1_1_1_1_1',
          duration: 120,
          track: 5,
          target: {
            scale: {
              x: 1.05,
              y: 0.95
            }
          },
          startAt: 2000,
          sourceName: 'clap',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '66dc6a41-e068-437f-826b-f61bd75281fc',
          type: 'Tween',
          name: 'clapScale_1_1_1_1_1_1',
          duration: 130,
          track: 5,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 2120,
          sourceName: 'clap',
          easing: 'QuadraticOut',
          disabled: false
        }
      ]
    },
    {
      id: '86915a2d-df9a-4819-917c-cd3d3c284888',
      name: 'Unlock',
      playingSpeed: 1,
      totalDuration: 1250,
      blocks: [
        {
          id: '02e60587-5384-4e70-9d2b-50d2d48c63a9',
          type: 'Tween',
          name: 'textScale',
          duration: 100,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'freeText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'da610545-2077-4528-a0b6-102fed3c71c8',
          type: 'Setter',
          name: 'FXPART_Unlock_Tile_Particles',
          track: 11,
          target: {},
          startAt: 50,
          sourceName: 'particles',
          disabled: false
        },
        {
          id: 'ffabc604-35e6-4538-b862-b75a29b09573',
          type: 'Tween',
          name: 'clapTopRotation_4',
          duration: 150,
          track: 7,
          target: {
            angle: 13
          },
          startAt: 50,
          sourceName: 'clapTop',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '402e91ba-7389-4a5a-ab0b-bd4f482d8c86',
          type: 'Tween',
          name: 'clapScale_3',
          duration: 100,
          track: 3,
          target: {
            scale: {
              x: 0.9,
              y: 0.8
            }
          },
          startAt: 50,
          sourceName: 'clap',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c4d92649-7658-4cfe-85ef-615cb05deda0',
          type: 'Tween',
          name: 'highlightAlpha',
          duration: 200,
          track: 9,
          target: {
            alpha: 1
          },
          startAt: 100,
          sourceName: 'highlight',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'abcaf002-2e6c-4f49-a856-5bd37fbf07f1',
          type: 'Tween',
          name: 'textScale_1',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 100,
          sourceName: 'freeText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7b38a785-61e7-46d4-ac00-51d62d33fb42',
          type: 'Setter',
          name: 'SFX_Gameplay_Unlock_Tile',
          track: 10,
          target: {},
          startAt: 150,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '88a9faa2-fe5b-4e2e-af77-aa837059f401',
          type: 'Tween',
          name: 'clapTopWhiteAlpha_2',
          duration: 200,
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 150,
          sourceName: 'clapTopWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b2242388-4051-44a1-9102-17ef95237195',
          type: 'Tween',
          name: 'clapPosition_2',
          duration: 300,
          track: 4,
          target: {
            y: 0
          },
          startAt: 150,
          sourceName: 'clap',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0b2d3feb-753f-4976-87ad-fa91dae9512b',
          type: 'Tween',
          name: 'clapScale_3_1',
          duration: 300,
          track: 3,
          target: {
            scale: {
              x: 1.2,
              y: 1.3
            }
          },
          startAt: 150,
          sourceName: 'clap',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '06e645f1-57a7-4151-b82b-49e7c2bd7387',
          type: 'Tween',
          name: 'clapBottomWhiteAlpha_2',
          duration: 200,
          track: 5,
          target: {
            alpha: 1
          },
          startAt: 150,
          sourceName: 'clapBottomWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ac38e676-56ca-4566-ac01-5f1be6ef2bc5',
          type: 'Tween',
          name: 'clapTopRotation_4_1',
          duration: 150,
          track: 7,
          target: {
            angle: 0
          },
          startAt: 200,
          sourceName: 'clapTop',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b1957194-ffda-4277-ab6d-df0378678350',
          type: 'Tween',
          name: 'highlightAlpha_1',
          duration: 250,
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 300,
          sourceName: 'highlight',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a8a5e6d8-5250-4c8d-9710-fffdf09fe44f',
          type: 'Tween',
          name: 'clapAlpha',
          duration: 150,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 300,
          sourceName: 'clap',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'f0e73fcc-4fd5-420b-b01a-d283fc72e1c0',
          type: 'Tween',
          name: 'darkTileAlpha',
          duration: 300,
          track: 12,
          target: {
            alpha: 0
          },
          startAt: 450,
          sourceName: 'darkTile',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class AdBlockerLayout {
  static raw = raw;
  root!: Container;
  darkTile!: Sprite;
  highlight!: Sprite;
  particles!: Container;
  clap!: Container;
  freeText!: Text & { data: typeof raw['list'][5]['data'] };
  clapTop!: Container;
  clapBottom!: Container;
  clapTopNormal!: Sprite;
  clapTopWhite!: Sprite;
  clapBottomNormal!: Sprite;
  clapBottomWhite!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Idle {
  Layout: {
    clap: object;
    clapTopWhite: object;
    clapTop: object;
    clapBottomWhite: object;
  };

  BlockTypeByName: {
    clapScale: object;
    clapPosition_1_copy: object;
    clapScale_1: object;
    clapPosition_1: object;
    clapTopWhiteAlpha: object;
    clapTopRotation: object;
    clapBottomWhiteAlpha: object;
    clapTopRotation_1: object;
    clapTopRotation_2: object;
    clapScale_1_1: object;
    clapTopRotation_3: object;
    clapBottomWhiteAlpha_1: object;
    clapTopWhiteAlpha_1: object;
    clapPosition: object;
    clapScale_1_1_1: object;
    clapScale_1_1_1_1: object;
    clapScale_1_1_1_1_1: object;
    clapScale_1_1_1_1_1_1: object;
  };

  flowData = raw.animations[0];
}

export abstract class Unlock {
  Layout: {
    freeText: object;
    particles: object;
    clapTop: object;
    clap: object;
    highlight: object;
    root: object;
    clapTopWhite: object;
    clapBottomWhite: object;
    darkTile: object;
  };

  BlockTypeByName: {
    textScale: object;
    FXPART_Unlock_Tile_Particles: object;
    clapTopRotation_4: object;
    clapScale_3: object;
    highlightAlpha: object;
    textScale_1: object;
    SFX_Gameplay_Unlock_Tile: object;
    clapTopWhiteAlpha_2: object;
    clapPosition_2: object;
    clapScale_3_1: object;
    clapBottomWhiteAlpha_2: object;
    clapTopRotation_4_1: object;
    highlightAlpha_1: object;
    clapAlpha: object;
    darkTileAlpha: object;
  };

  flowData = raw.animations[1];
}
